"use strict";

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import { STATIC_MFE_URL } from '@autoguru/global-configs';
import { getBasePath } from './get-base-path';

/**
 * Resolves the public path for loading translation assets
 * Handles development, local production testing, and deployed environments
 */
export function resolvePublicPath(options) {
  const {
    appName = '',
    publicPath,
    isDevelopment = false
  } = options || {};

  // In development mode, use simple local path
  if (isDevelopment || typeof (process.env.NODE_ENV !== "production") !== 'undefined' && process.env.NODE_ENV !== "production") {
    return '';
  }

  // Production mode: Use STATIC_MFE_URL if available
  if (STATIC_MFE_URL && typeof STATIC_MFE_URL === 'string') {
    // Use GDU-provided app name or fallback to options
    const resolvedAppName = typeof __GDU_APP_NAME__ !== 'undefined' ? __GDU_APP_NAME__ : appName;

    // Clean up the app name - remove @autoguru/ prefix if present
    const cleanAppName = resolvedAppName.replace('@autoguru/', '');

    // Ensure STATIC_MFE_URL ends with / and appName doesn't start with /
    const baseUrl = STATIC_MFE_URL.endsWith('/') ? STATIC_MFE_URL : `${STATIC_MFE_URL}/`;
    const appPath = cleanAppName.startsWith('/') ? cleanAppName.slice(1) : cleanAppName;
    const resolvedPath = `${baseUrl}${appPath}`;
    // Ensure path ends with / for proper path joining
    return resolvedPath.endsWith('/') ? resolvedPath : `${resolvedPath}/`;
  }

  // Fallback to configured public path or auto-detect
  const fallbackPath = publicPath || getBasePath() || '';
  return fallbackPath.endsWith('/') ? fallbackPath : `${fallbackPath}/`;
}

/**
 * Constructs the full URL for a translation asset
 * Handles both relative and absolute paths
 */
export function getFullTranslationPath(publicPath, relativePath) {
  // If the path is already absolute (starts with http), return as-is
  if (relativePath.startsWith('http')) {
    return relativePath;
  }

  // Remove leading slash from relativePath if publicPath ends with slash
  const cleanPath = publicPath.endsWith('/') && relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
  return `${publicPath}${cleanPath}`;
}

/**
 * Gets the default locale based on browser settings
 */
export function getDefaultLocale(supportedLocales = ['en']) {
  if (typeof navigator !== 'undefined' && navigator.language) {
    const browserLang = navigator.language.split('-')[0];
    return supportedLocales.includes(browserLang) ? browserLang : 'en';
  }
  return 'en';
}